'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _dec, _desc, _value, _class, _descriptor, _descriptor2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = require('mobx');

var _baseComponent = require('base-component');

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _baseContentmodel = require('base-contentmodel');

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _trcSimgate = require('trc-simgate');

var _trcSimgate2 = _interopRequireDefault(_trcSimgate);

var _trcAsyncTask = require('trc-async-task');

var _trcAsyncTask2 = _interopRequireDefault(_trcAsyncTask);

var _simgateContentmodel = require('simgate-contentmodel');

var _simgateContentmodel2 = _interopRequireDefault(_simgateContentmodel);

var _simgateDatamodel = require('simgate-datamodel');

var _simgateDatamodel2 = _interopRequireDefault(_simgateDatamodel);

var _projectDomainStore = require('project-domain-store');

var _projectDomainStore2 = _interopRequireDefault(_projectDomainStore);

var _authoringModulesWebpackContext = require('authoring-modules-webpack-context');

var _authoringModulesWebpackContext2 = _interopRequireDefault(_authoringModulesWebpackContext);

var _projectEntity = require('project-entity');

var _systemEntity = require('system-entity');

var _configurationEntity = require('configuration-entity');

var _viewstore = require('confirmation-modal/viewstore');

var _viewstore2 = _interopRequireDefault(_viewstore);

var _viewstore3 = require('ui-blocking-modal/viewstore');

var _viewstore4 = _interopRequireDefault(_viewstore3);

var _package = require('~/package.json');

var _package2 = _interopRequireDefault(_package);

require('./css/core.css');

require('~/css/app.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

document.title = window.pageTitle || _package2.default.description || "The Regis Company - Authoring Tool";

var blockingModalState = new _viewstore4.default();
var modalViewStore = new _viewstore2.default({});

// global async task runner
var asyncTask = new _trcAsyncTask2.default({
  maximumParallel: 1,
  onFailure: function onFailure(err) {
    // @TODO how does simgate timeout work?
    if ((err instanceof Error && err.message.toLowerCase().indexOf("access denied")) > -1 || typeof err === "string" && err.toLowerCase().indexOf("access denied") > -1) {
      return console.log("bailed failure alert because this is access denied error, which indicates expired session");
    } else if ((err instanceof Error && err.message.toLowerCase().indexOf("code error")) > -1 || typeof err === "string" && err.toLowerCase().indexOf("code error") > -1) {
      modalViewStore.setModal({
        title: "Error",
        message: _react2.default.createElement(
          'div',
          null,
          'Please contact a developer, this functionality is broken.',
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'pre',
            { style: { fontSize: "8px" } },
            err.message
          )
        ),
        confirmLabel: 'Continue',
        confirmBtnClass: 'green'
      });
    } else {
      alert("Your request to the application has failed. Please wait 10 seconds and try again.");
    }
  },
  onRun: function onRun() {
    console.log("starting queue");
    // add wait screen
    blockingModalState.saveInProgress = true;
  },
  onDone: function onDone(err) {
    console.log("done with queue");
    // remove wait screen
    blockingModalState.saveInProgress = false;
  }
});

var simgate = window.simgate = new _trcSimgate2.default({
  debug: true,
  crossDomain: true,
  url: window.trcAppSettings && window.trcAppSettings.apiUrl || _package2.default.apiUrl || "http://platform.dev.regis-co.com/",
  trace: { limit: 50, updateData: true }
});

simgate.runTask = asyncTask.runTask.bind(asyncTask);

var Application = (_dec = _mobx.observable.ref, (_class = function () {
  function Application() {
    var _this = this;

    (0, _classCallCheck3.default)(this, Application);
    this.contentModel = new _simgateContentmodel2.default({
      simgate: simgate,
      webpackLoader: _authoringModulesWebpackContext2.default
    });
    this.dataModel = new _simgateDatamodel2.default({
      simgate: simgate
      // DO NOT ADD STORE HERE, will not respect mock override settings 
      // stores: [ProjectDomainStore]
      // onFail: () => alert(this.contentModel.projectContentStore["G:LoadFailed:G"])
    });
    this.blockingModalState = blockingModalState;
    this.modalViewStore = modalViewStore;

    _initDefineProp(this, 'isSettingUp', _descriptor, this);

    _initDefineProp(this, 'Configuration', _descriptor2, this);

    this.simDataModels = {};
    this.simgate = simgate;
    this.runTask = asyncTask.runTask.bind(asyncTask);

    this.dataModel.addStore(_projectDomainStore2.default);
    this.contentModel.entities.set("System", new _systemEntity.ContentModel());
    this.contentModel.loadEntities();

    (0, _mobx.when)(function () {
      return _this.contentModel.hasHydrated;
    }, function () {
      if (!(_this.Project = _this.contentModel.entities.get("Project_FlowEditor"))) {
        _this.Project = new _projectEntity.ContentModel({ id: "Project_FlowEditor", displayName: "Flow Editor" });
        _this.Project.saveEntity();
      }

      if (!(_this.Configuration = _this.contentModel.entities.get("Configuration"))) {
        _this.Configuration = new _configurationEntity.ContentModel({ id: "Configuration" }, _this);
        _this.Configuration.saveEntity();
      }

      var System = _this.contentModel.entities.get("System");

      window.viewEntities = function () {
        modalViewStore.setModal({
          title: "Entities",
          confirmLabel: 'Continue',
          confirmBtnClass: 'green check-a',
          message: _react2.default.createElement(
            'pre',
            { style: { fontSize: "8px", maxWidth: "500px" } },
            System.publishEntities({
              cm: _this.Configuration,
              path: "entities",
              outputToString: true
            })
          )
        });
      };

      window.importEntities = function () {
        modalViewStore.setModal({
          title: "Import Entities",
          confirmLabel: 'Continue',
          confirmBtnClass: 'green check-a',
          message: _react2.default.createElement('textarea', { className: 'import-entities-textarea' }),
          onConfirmFunc: function onConfirmFunc(e) {
            var confModalEl = e.target;
            while (confModalEl.className.indexOf("confirmation-modal") === -1) {
              confModalEl = confModalEl.parentNode;
            }var textarea = confModalEl.querySelector('textarea');
            var value = textarea.value;
            var parsed = void 0;
            try {
              parsed = JSON.parse(value);
            } catch (e) {
              modalViewStore.setModal({
                title: "Import Entities - Error",
                confirmLabel: 'Continue',
                confirmBtnClass: 'green check-a',
                message: e.message
              });
            }
            var ents = window.application.contentModel.hydrateEntities(parsed);
            var ids = [];
            var queue = 0;
            ents.forEach(function (ent) {
              queue++;
              ids.push(ent.id);
              ent.saveEntity(function () {
                return final(--queue);
              });
            });
            function final(queue) {
              if (!queue) {
                modalViewStore.setModal({
                  title: "Import Entities - Success",
                  confirmLabel: 'Continue',
                  confirmBtnClass: 'green check-a',
                  message: _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'div',
                      null,
                      'You have successfully imported these entities!'
                    ),
                    ids.map(function (id) {
                      return _react2.default.createElement(
                        'div',
                        null,
                        id
                      );
                    })
                  )
                });
              }
            }
          }
        });
      };

      // clear your routes, normally dont want to do this
      // this.Configuration.routes.clear();
      // this.Configuration.saveEntity();

      (0, _assign2.default)(System, {
        types: _this.contentModel.types["TypeContentModel"].allEntities(),
        configuration: _this.Configuration,
        project: _this.Project
      });

      (0, _mobx.when)(function () {
        return _this.Project.guid && _this.Configuration.guid;
      }, function () {
        var _Configuration$warnin = _this.Configuration.warning,
            noAdminRole = _Configuration$warnin.noAdminRole,
            noAdminRoute = _Configuration$warnin.noAdminRoute,
            duplicateRoutes = _Configuration$warnin.duplicateRoutes;
        var domainStore = _this.dataModel.domainStore;


        if (noAdminRoute || noAdminRole || duplicateRoutes) {
          _this.isSettingUp = true;
        } else if (_this.route) {
          (0, _mobx.when)(function () {
            return _this.role;
          }, function () {
            // set readOnlyAccessTypes for this role to readonly!       
            // @TODO make this pluggable per route content model
            // @TODO make this exposed to custom auth strat ??               
            if (_this.role.readOnlyAccessTypes && _this.role.readOnlyAccessTypes.length) {
              _this.role.readOnlyAccessTypes.forEach(function (type) {
                var ContentModel = _this.contentModel.types[type.id];
                ContentModel.readonly = true;
                ContentModel.allEntities().forEach(function (type2) {
                  return type2.readonly = true;
                });
              });
            }

            // if authStrategy has its own signOut, overwrite domainStore's signOut
            // and provide application as context
            if (_this.route.authStrategy && _this.route.authStrategy.signOut) {
              domainStore.signOut = function () {
                return _this.route.authStrategy.signOut.call(_this);
              };
            }
          });
        }
      });
    });
  }

  (0, _createClass3.default)(Application, [{
    key: 'route',
    get: function get() {
      if (!this.Configuration) return null;
      return this.Configuration.routes.find(function (r) {
        return r.urlmatch === window.location.search.substring(1);
      });
    }
  }, {
    key: 'role',
    get: function get() {
      var domainStore = this.dataModel.domainStore;

      if (!this.route || !domainStore.context.user.roleID) return null;
      return this.route.roles.find(function (role) {
        return role.roleId === domainStore.context.user.roleID;
      });
    }
  }, {
    key: 'viewMap',
    get: function get() {
      var _this2 = this;

      var domainStore = this.dataModel.domainStore;
      var route = this.route,
          Configuration = this.Configuration;


      if (!Configuration) return {};

      var _Configuration$warnin2 = Configuration.warning,
          noAdminRole = _Configuration$warnin2.noAdminRole,
          noAdminRoute = _Configuration$warnin2.noAdminRoute,
          duplicateRoutes = _Configuration$warnin2.duplicateRoutes;


      if (!domainStore) throw new Error("missing domain store!");

      if (!noAdminRole && !noAdminRoute && !duplicateRoutes && this.isSettingUp) {
        return {
          "init-done": {
            id: "init-done",
            Component: function Component() {
              return _react2.default.createElement(
                'button',
                { onClick: function onClick(e) {
                    return window.location.reload();
                  } },
                'Reload'
              );
            }
          }
        };
      } else if ( /*(noAdminRole || noAdminRoute || duplicateRoutes) &&*/this.isSettingUp) {
        //@TODO why are project-layout and app separate now? merge them so can just leverage layout-component
        return {
          "init": {
            id: "init",
            contentModel: Configuration,
            options: {
              init: true
            }
          }
        };
      } else if (!route) {
        return {
          "badurl": {
            id: "badurl",
            Component: function Component() {
              return _react2.default.createElement(
                'div',
                null,
                'Bad url.'
              );
            }
          }
        };
      } else if (typeof route.authStrategy.done === "string" && eval(route.authStrategy.done) || (0, _mobx.isObservable)(route.authStrategy, "done") && !!route.authStrategy.done) {
        return route.destinations.reduce(function (acc, destination) {
          if (!destination || !destination.id) return acc;
          acc[destination.id] = {
            id: destination.id,
            contentModel: destination,
            displayTitle: destination.displayTitle || destination.displayName,
            application: _this2,
            show: true
          };
          return acc;
        }, {});
      } else {
        return {
          "auth": {
            id: "auth",
            contentModel: route.authStrategy,
            route: route,
            options: { auth: true }
          }
        };
      }
    }
  }]);
  return Application;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'isSettingUp', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'Configuration', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'route', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'route'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'role', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'role'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'viewMap', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'viewMap'), _class.prototype)), _class));
exports.default = Application;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(blockingModalState, 'blockingModalState', 'src/core_modules/authoring-application/app.js');

  __REACT_HOT_LOADER__.register(modalViewStore, 'modalViewStore', 'src/core_modules/authoring-application/app.js');

  __REACT_HOT_LOADER__.register(asyncTask, 'asyncTask', 'src/core_modules/authoring-application/app.js');

  __REACT_HOT_LOADER__.register(simgate, 'simgate', 'src/core_modules/authoring-application/app.js');

  __REACT_HOT_LOADER__.register(Application, 'Application', 'src/core_modules/authoring-application/app.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/authoring-application/app.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/authoring-application/app.js
// module chunks = 0